module.exports = __webpack_public_path__ + "img/semi-ajoure.383b6ee.svg";